// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    base_url: 'https://stgnano.probietech.com/v1',
    firebase: {
        apiKey: 'AIzaSyDmXmNui455hMO6VjJLwGJQNKfcnVqKdcw',
        authDomain: 'stg-pramukh.firebaseapp.com',
        projectId: 'stg-pramukh',
        storageBucket: 'stg-pramukh.appspot.com',
        messagingSenderId: '666285295464',
        appId: '1:666285295464:web:7534f5793ec9c77e7338dd',
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
